import { useState, useEffect } from "react";

// Componentes
import Modal from "../Modal";
import OrdenPagoLista from "./OrdenPagoLista";

import campoDeNumeros from "../../helpers/datos/campoDeNumeros";
import VerificarUsuario from "../../helpers/usuario/verificarUsuario";
import obtener from "../../helpers/contribuyente/contribuyente/obtener";
import mensajePreventivo from "../../helpers/mensajes/mensajePreventivo";
import obtenerPorPlacas from "../../helpers/contribuyente/contribuyente/obtenerPorPlacas";
import campoExclusivoNumerosEjercicio from "../../helpers/datos/campoExclusivoNumerosEjercicio";
import obtenerPorIdConcesion from "../../helpers/contribuyente/contribuyente/obtenerPorIdConcesion";

import { buscarTramiteIndex } from "../../helpers/catalogos/metodos/buscarTramiteIndex";
import { buscarConceptoPagosIndex } from "../../helpers/catalogos/metodos/buscarConceptoPagosIndex";
import { tramitesObligatorios, conceptosObligatorios } from "../../helpers/poliza/obligatorios";

/* { catalogos, dataLoaded, data, setData, nuevosTramites, setNuevosTramites, setAPagar,
    vigencia, setVigencia, observaciones, setObservaciones, anualidad, setAnualidad } */
export default function OrdenPago(props) {

    VerificarUsuario();
    console.clear();
    const { tramites, conceptoPagos } = props.catalogos;
    const { concesionActual, contribuyente } = props.data;

    const [isModalOpen, setModalIsOpen] = useState(false);
    const [contribuyentes, setContribuyentes] = useState([]);

    const toggleModal = () => setModalIsOpen(!isModalOpen);

    const [idTramite, setIdTramite] = useState(null);
    const [idConceptoPago, setIdConceptoPago] = useState(null);
    const [tarifaMinima, setTarifaMinima] = useState(0);
    const [tarifaMaxima, setTarifaMaxima] = useState(150);
    const [key, setKey] = useState(0);
    const [cri, setCri] = useState("");
    const [importe, setImporte] = useState("");
    const [ejercicio, setEjercicio] = useState(2023);
    const [idUnidadCobro, setIdUnidadCobro] = useState(null);

    const cambiarTramite = e => {
        setIdTramite(Number(e));
        if (conceptoPagos.filter(item => item.idTramite === e).length >= 1) {
            setIdConceptoPago(Number(conceptoPagos.filter(item => item.idTramite === e)[0].idConceptoPago))
        }
        else {
            setTarifaMinima(0);
            setTarifaMaxima(500);
        }
    }

    const cambiarConcepto = e => {
        setIdConceptoPago(Number(e))
        const valorMinimo = Number(conceptoPagos.filter(concepto => concepto.idConceptoPago === Number(e))[0]?.tarifaMinima);
        const valorMaximo = Number(conceptoPagos.filter(concepto => concepto.idConceptoPago === Number(e))[0]?.tarifaMaxima);
        setTarifaMinima(valorMinimo);
        setTarifaMaxima(valorMaximo);
        setImporte(Math.max(valorMinimo, valorMaximo) ?? 0);
        setEjercicio(Number(conceptoPagos.filter(concepto => concepto.idConceptoPago === Number(e))[0]?.ejercicioFiscal));
        setCri(conceptoPagos.filter(concepto => concepto.idConceptoPago === Number(e))[0]?.cri);
        setIdUnidadCobro(conceptoPagos.filter(concepto => concepto.idConceptoPago === Number(e))[0]?.idUnidadCobro);
    }

    const agregarTramite = () => {

        if (props.nuevosTramites.length < 10) {
            if (!contribuyente || !props.data.contribuyente) {
                mensajePreventivo("Necesita un contribuyente")
            }
            if (tramitesObligatorios.includes(idTramite) && conceptosObligatorios.includes(idConceptoPago) && (props.data?.concesiones.length ?? 0) < 1) {
                mensajePreventivo("Se requiere de alguna concesión");
            }
            else {

                if (tarifaMinima === null && tarifaMaxima === null) {
                    setTarifaMinima(0);
                    setTarifaMaxima(500);
                }
                const indexTramite = buscarTramiteIndex(idTramite, props.catalogos?.tramites);
                const conceptosPagosLista = conceptoPagos.filter(item => item.idTramite === idTramite);

                let tramiteTexto = tramites[indexTramite].nombre;
                let conceptoTexto = ""

                if (conceptosPagosLista.length === 0) conceptoTexto = "-";
                else if (idConceptoPago === null) conceptoTexto = conceptosPagosLista[0].descripcion;
                else {
                    const indexConcepto = buscarConceptoPagosIndex(idConceptoPago, conceptosPagosLista);
                    conceptoTexto = conceptosPagosLista[indexConcepto].descripcion;
                }

                const re = new RegExp("\"", "g");
                tramiteTexto = tramiteTexto.replace(re, "'")
                if (importe !== "" && Number(importe) !== 0) {
                    if (Number(tarifaMinima) <= Number(importe) && Number(importe) <= Number(tarifaMaxima)) {
                        props.setNuevosTramites(
                            [...props.nuevosTramites, {
                                ejercicio: ejercicio,
                                idTramite: idTramite,
                                idConceptoPago: idConceptoPago,
                                tramite: tramiteTexto.trim(),
                                concepto: conceptoTexto.trim(),
                                importe: Number(importe),
                                key: key,
                                cri: cri.replace(re, "'"),
                                idUnidadCobro: idUnidadCobro,
                            }]);
                        setKey(key => Math.floor(Math.random() * 10_000) + key);
                    }
                    else {
                        mensajePreventivo("Ingrese un importe dentro del mínimo y máximo de UMAS");
                    }
                }
            }

        }
    }



    useEffect(() => { }, [idTramite, idConceptoPago]);

    return (

        <div className="contenedorMain">

            <div className="formulario">
                <div className="boxRow">
                    <div className="boxColumn">
                        <label className="lblCampo">Turno</label>
                        <div className="search-bar">
                            <input type="text" />
                        </div>
                    </div>

                    {/* Nombre del contribuyente*/}
                    <div className="boxColumn flex3">
                        <label className="lblCampo" id="lblContribuyente">Contribuyente</label>
                        <div className="search-bar" onKeyDown={e => e.key === "Enter" && obtener(contribuyente, props.setData, setContribuyentes, setModalIsOpen)}>
                            {/* Nombre */}
                            <input className="actions" id="inputNombre" type="text" placeholder="Nombre(s)"
                                value={contribuyente?.nombre === undefined ? "" : contribuyente?.nombre.toUpperCase()}
                                onChange={e => props.setData({ ...props.data, contribuyente: { ...contribuyente, nombre: e.target.value.toUpperCase() } })}
                            />

                            {/* Apellido paterno*/}
                            {!contribuyente?.tipoPersona && (
                                <input className="actions" id="inputApellidoP" type="text" placeholder="Apellido Paterno"/*  */
                                    value={contribuyente?.apellidoPaterno === undefined ? "" : contribuyente?.apellidoPaterno.toUpperCase()}
                                    onChange={e => props.setData({ ...props.data, contribuyente: { ...contribuyente, apellidoPaterno: e.target.value.toUpperCase() } })}
                                />
                            )}

                            {/* Apellido materno */}
                            {!contribuyente?.tipoPersona && (
                                <input className="actions" id="inputApellidoM" type="text" placeholder="Apellido Materno"
                                    value={contribuyente?.apellidoMaterno === undefined ? "" : contribuyente?.apellidoMaterno.toUpperCase()}
                                    onChange={e => props.setData({ ...props.data, contribuyente: { ...contribuyente, apellidoMaterno: e.target.value.toUpperCase() } })}
                                />
                            )}

                            {/* Buscar */}
                            <div className="actions">
                                <button onClick={() => obtener(contribuyente, props.setData, setContribuyentes, setModalIsOpen)}>
                                    <span className="material-symbols-outlined">
                                        search
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* RFC */}
                    <div className="boxColumn">
                        <label className="lblCampo">RFC</label>
                        <div className="search-bar" onKeyDown={e => e.key === "Enter" && obtener(contribuyente, props.setData, setContribuyentes, setModalIsOpen)}>
                            <input className="actions" type="text"
                                value={contribuyente?.rfc === undefined ? "" : contribuyente?.rfc.toUpperCase()}
                                onChange={e => props.setData({ ...props.data, contribuyente: { ...contribuyente, rfc: e.target.value.toUpperCase() } })}
                            />
                            <div className="actions">
                                <button onClick={() => obtener(contribuyente, props.setData, setContribuyentes, setModalIsOpen)}>
                                    <span className="material-icons">search</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Vigencia Orden de pago */}
                    <div className="boxColumn">
                        <label className="lblCampo">Vigencia O.P.</label>
                        <div className="search-bar">
                            <input type="date" value={props.vigencia} onChange={e => props.setVigencia(e.target.value)} />
                        </div>
                    </div>
                </div>

                <div className="boxRow">
                    {/* Número de placas */}
                    <div className="boxColumn">
                        <label className="lblCampo">No. Placas</label>
                        <div className="search-bar" onKeyDown={e => e.key === "Enter" && obtenerPorPlacas(props.data, props.setData)}>
                            <input className="actions" type="text"
                                value={concesionActual?.seriePlaca === undefined ? "" : concesionActual?.seriePlaca.toUpperCase()}
                                onChange={e => props.setData({ ...props.data, concesionActual: { ...concesionActual, seriePlaca: e.target.value.toUpperCase() } })}
                            />
                            <div className="actions" onClick={() => obtenerPorPlacas(props.data, props.setData)}>
                                <button><span className="material-icons">search</span></button>
                            </div>
                        </div>
                    </div>

                    {/* Concesión */}
                    <div className="boxColumn">
                        <label className="lblCampo">Concesión</label>
                        <div className="search-bar" onKeyDown={e => e.key === "Enter" && obtenerPorIdConcesion(props.data, props.setData)}>
                            <input className="actions" type="text"
                                value={concesionActual?.idConcesion === undefined ? "" : concesionActual?.idConcesion}
                                onChange={e => props.setData({ ...props.data, concesionActual: { ...concesionActual, idConcesion: e.target.value.toUpperCase() } })}
                            />
                            <div className="actions" onClick={() => obtenerPorIdConcesion(props.data, props.setData)}>
                                <button><span className="material-icons">search</span></button>
                            </div>
                        </div>
                    </div>

                    {/* Número de expediente */}
                    <div className="boxColumn">
                        <label className="lblCampo">Expediente</label>
                        <div className="search-bar">
                            <input className="actions" type="text"
                                value={concesionActual?.numeroExpediente === undefined ? "" : concesionActual?.numeroExpediente}
                                onChange={e => props.setData({ ...props.data, concesionActual: { ...concesionActual, numeroExpediente: e.target.value.toUpperCase() } })}
                            />
                            {/* <div className="actions" onClick={() => buscarConcesionarioPorNumeroExpediente(props.data, props.setData)}>
                                <button><span className="material-icons">search</span></button>
                            </div> */}
                        </div>
                    </div>

                    {/* Mnemotécnica */}
                    <div className="boxColumn">
                        <label className="lblCampo">Mnemotécnica</label>
                        <div className="search-bar">
                            <input className="actions" type="text" disabled
                                value={concesionActual?.mnemotecnia === undefined ? "" : concesionActual?.mnemotecnia}
                                onChange={e => props.setData({ ...props.data, concesionActual: { ...concesionActual, mnemotecnia: e.target.value.toUpperCase() } })}
                            />
                            {/* <div className="actions">
                                <button><span className="material-icons">search</span></button>
                            </div> */}
                        </div>
                    </div>

                    {/* Ejercicio/Anualidad */}
                    <div className="boxColumn">
                        <label className="lblCampo">Ejercicio</label>
                        <div className={`search-bar`}>
                            <input type="text" placeholder="2023"
                                maxLength="4"
                                /* disabled={!opciones.includes(idTramite)} */
                                value={props.anualidad} onChange={e => campoExclusivoNumerosEjercicio(e.target.value, props.setAnualidad)} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Observaciones */}
            <div className="boxRow">
                <div className="boxColumn">
                    <label className="lblCampo">
                        Observaciones
                    </label>
                    <div className="search-bar-textarea">
                        <textarea name="textarea" rows="1" cols="1"
                            value={props.observaciones}
                            onChange={e => props.setObservaciones(e.target.value.toUpperCase())}
                        /* disabled={!opciones.includes(idTramite)}
                        style={{ cursor: !opciones.includes(idTramite) && "not-allowed" }} */
                        >
                        </textarea>
                    </div>
                </div>
            </div>

            {/* ... Separador ... */}
            <div className="boxRow divider"><div></div></div>

            <div className="boxRow">
                {/* Trámite */}
                <div className="boxColumn flex2">
                    <label className="lblCampo">Tramite</label>
                    <div className="search-bar">
                        <select id="selectLugarN" onChange={e => cambiarTramite(Number(e.target.value))}>
                            <option value="">-- SELECCIONAR TRÁMITE --</option>
                            {props.dataLoaded &&
                                props.catalogos.tramites.filter(item => item.vigente === 1).map(tramite =>
                                    <option
                                        key={tramite.idTramite}
                                        value={tramite.idTramite}
                                        selected={tramite.idTramite === idTramite}
                                        title={tramite.nombre.toUpperCase().trim()}>
                                        {tramite.nombre.toUpperCase().trim()}
                                    </option>
                                )
                            }
                        </select>
                    </div>
                </div>

                {/* Concepto */}
                <div className="boxColumn flex2">
                    <label className="lblCampo">Concepto</label>
                    <div className="search-bar">
                        <select id="selectLugarN" onChange={e => cambiarConcepto(Number(e.target.value))}>
                            {props.dataLoaded &&
                                props.catalogos.conceptoPagos.filter(item => item.idTramite === idTramite).length > 0 &&
                                <option value="">--SELECCIONAR CONCEPTO--</option>
                            }
                            {props.dataLoaded &&
                                props.catalogos.conceptoPagos.filter(item => item.idTramite === idTramite).map(concepto =>
                                    <option key={concepto.idConceptoPago} value={concepto.idConceptoPago} title={concepto.descripcion.toUpperCase()} >
                                        {concepto.descripcion.toUpperCase().length < 90 ?
                                            concepto.descripcion.toUpperCase() :
                                            `${concepto.descripcion.toUpperCase().substring(0, 89)}...`}
                                    </option>
                                )
                            }
                        </select>
                    </div>
                </div>

                {/* Tarifas */}
                <div className="boxColumn">
                    <label className="lblCampo">Unidad min-max</label>
                    <div className="search-bar">
                        <input type="text"
                            placeholder={`$${tarifaMinima ?? ``} - $${tarifaMaxima ?? ``}(${conceptoPagos &&
                                conceptoPagos[buscarConceptoPagosIndex(idConceptoPago, conceptoPagos)]
                                    
                                    ?.idUnidadCobro === 1 ? (props.catalogos?.uma?.valor ?? "") + " S.M.V.)" : "Pesos)"}`}
                            disabled 
                        />
                    </div>
                </div>

                {/* Importe */}
                <div className="boxColumn">
                    <label className="lblCampo">Importe</label>
                    <div className="search-bar">
                        <input type="text" placeholder="$" value={importe} onChange={e => campoDeNumeros(e.target.value, setImporte)} />
                    </div>
                </div>

                {/* Agregar nuevo trámite */}
                <div className="actions" onClick={agregarTramite}><button><span className="material-icons">add_box</span></button></div>
            </div>

            {isModalOpen && <Modal onRequestClose={toggleModal} contribuyentes={contribuyentes} setData={props.setData} />}

            <OrdenPagoLista tramites={props.nuevosTramites} catalogos={props.catalogos} setAPagar={props.setAPagar} />

        </div>


    );
}
